<template>
  <v-container fluid class="webConPerson-management mt-4 px-1">
    <v-row>

      <template>
        <v-row justify="center">
          <v-dialog
              v-model="dialog_upload"
              width="1250px"
          >
            <v-card>

              <UploadManagement
                  id="ConPerson_UploadManagement">

              </UploadManagement>

            </v-card>


          </v-dialog>
        </v-row>
      </template>


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการเนื้อหาเว็บไซต์(ข้อมูลสมาชิก/บุคลากร)</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{
              '\xa0 (' + webConPersons.length
            }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items="webConPersons"
                :search="search"
                sort-by="persons_id">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='editForm'">
                  <v-text-field
                      v-model="editForm.persons_url"
                      :counter="45"
                      :rules="editForm.textReqRules.concat(editForm.URLRules)"
                      label="URL(ID) เนื้อหาเว็บไซต์"
                      required
                      disabled
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="2" v-else>
                  <v-text-field
                      v-model="editForm.persons_url"
                      :counter="45"
                      :rules="editForm.textReqRules.concat(editForm.URLRules)"
                      label="URL(ID) รหัสเนื้อหาเว็บไซต์"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="5">
                  <v-text-field
                      v-model="editForm.persons_title_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อเว็บไซต์ (TH)  (ข้อมูลสมาชิก/บุคลากร)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="5">
                  <v-text-field
                      v-model="editForm.persons_title_en"
                      :rules="editForm.textReqRules"
                      label="ชื่อเว็บไซต์ (EN)  (ข้อมูลสมาชิก/บุคลากร)"
                      required
                  ></v-text-field>
                </v-col>


              </v-row>


              <v-row v-for="(item,index) in editForm.ArrayData" :key="item.id">
                <div class="col" v-for="(itemC,indexC) in item.col" :key="item.id+'_'+indexC"
                     :style="'background-color: '+(item.row_number%2==0?'#ffe9f8':'#e9fcff')+';'"
                     style="border-radius: 25px; margin: 10px">

    <span :class="'v-chip theme--light v-size--small '+(item.row_number%2==0?'success':'primary ')">
      <span class="v-chip__content">แถวที่ {{ item.row_number }} ลำดับที่ {{ itemC.column_number }}</span>
    </span>

                  <v-select
                      v-model="editForm.ArrayData[index].col[indexC].user_name"
                      :items="users_combo"
                      item-text="full_name_th"
                      item-value="user_name"
                      label="ข้อมูลบุคลากร"
                      clearable
                  ></v-select>

                  <v-text-field v-model="editForm.ArrayData[index].col[indexC].position_th" label="ตำแหน่ง (TH)"></v-text-field>
                  <v-text-field v-model="editForm.ArrayData[index].col[indexC].position_en" label="ตำแหน่ง (EN)"></v-text-field>

                  <!-- <hr class="my-4" style="border: 0; border-top: 1px solid rgba(0,0,0,0.1);"> -->

                  <v-checkbox
                      v-model="editForm.ArrayData[index].col[indexC].show_duty"
                      label="ระบุอำนาจหน้าที่"
                      dense
                      hide-details
                      class="mb-2"
                  ></v-checkbox>

                  <div v-if="editForm.ArrayData[index].col[indexC].show_duty">
                    <!-- <small class="red--text">*กรณีที่ต้องการเว้นบรรทัดให้ใส่เครื่องหมาย ,</small> -->
                    <v-textarea
                        v-model="editForm.ArrayData[index].col[indexC].duty_th"
                        label="อำนาจหน้าที่ (TH)"
                        rows="2"
                        outlined
                        dense
                    ></v-textarea>

                    <v-textarea
                        v-model="editForm.ArrayData[index].col[indexC].duty_en"
                        label="อำนาจหน้าที่ (EN)"
                        rows="2"
                        outlined
                        dense
                    ></v-textarea>
                  </div>

                </div>
              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="4">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>

                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import Editor from '@tinymce/tinymce-vue';
import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';
import axios from "axios";

export default {
  name: 'ConPersonManagement',
  data() {
    return {
      // state: 'index',
      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      snackbar: null,
      dialog_upload: false,
      search: '',
      selected: [],
      headers: [
        {
          text: 'URL(ID)',
          align: 'start',
          value: 'persons_url',
        },
        {text: 'ชื่อ(TH)', value: 'persons_title_th'},
        {text: 'ชื่อ(EN)', value: 'persons_title_en'},
        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],


      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        persons_url: '',
        URLRules: validateRules.URLRules,
        textReqRules: validateRules.textReqRules,
        persons_title_th: '',
        persons_title_en: '',
        persons_content_th: '',
        persons_content_en: '',
        active: 'N',
        persons_objects: '',
        ArrayData: []

      },
      users_combo: [],
    }
  },
  components: {
    'editor': Editor, // <- Important part
    UploadManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_persons', ['webConPersons', "isReceiving", "isDeleting", "idToDelete", "webConPersonMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConPersonMessage() {

      if (this.webConPersonMessage !== '') {
        this.notification = this.webConPersonMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    console.log('xxx')
    this.getDcParamCombobox();
    this.buildDataArray();
    //ดึงฟังก์ชั่น จาก store
    this.getWebConPersonsRequest();

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_persons',
        [
          "getWebConPersonsRequest",
          "deleteWebConPersonRequest",
          "updateWebConPersonRequest",
          "createWebConPersonRequest"
        ]
    ),
    buildDataArray() {

      var index = 0;
      for (var i = 1; i <= 15; i++) {
        this.editForm.ArrayData[index] = {id: 'R' + i, row_number: i, col: []}
        for (var j = 1; j <= 5; j++) {
          this.editForm.ArrayData[index].col[j - 1] = {
            id: (i) + '' + j,
            column_number: j,
            user_name: '',
            position_th: '',
            position_en: '',
            duty_th: '',
            duty_en: '',
            show_duty: false
          }
        }
        index++
      }


    },

    async getDcParamCombobox() {

      try {


        await axios.post(config.baseURLApi + '/combo/' + 'usersActive', '', {
          headers: {},
        }).then(res => {
          this.users_combo = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }


    },

    addItem() {
      this.editedIndex = -1 //index = -1 add

      this.editForm.persons_url = null;
      this.editForm.persons_title_th = null;
      this.editForm.persons_title_en = null;
      this.editForm.persons_content_th = null;
      this.editForm.persons_content_en = null;
      this.editForm.active = 'Y';
      this.state = 'addForm';
      this.buildDataArray();

    },
    editItem(item) {

      this.editedIndex = this.webConPersons.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.persons_id = item.persons_id;
      this.editForm.persons_url = item.persons_url;
      this.editForm.persons_title_th = item.persons_title_th;
      this.editForm.persons_title_en = item.persons_title_en;
      this.editForm.persons_content_th = item.persons_content_th;
      this.editForm.persons_content_en = item.persons_content_en;
      this.editForm.persons_objects = item.persons_objects
      this.editForm.ArrayData = JSON.parse(item.persons_objects)
      this.editForm.active = item.active;

      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConPersonRequest({persons_id: item.persons_id})

    },
    close() {

      if (this.errorMessage == false || this.webConPersonMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {


      this.editForm.persons_objects = JSON.stringify(this.editForm.ArrayData)
      // console.log(this.editForm.persons_objects);

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConPersons[this.editedIndex], this.editForm)
            :
            this.updateWebConPersonRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConPersons.push(this.editForm)
            :
            this.createWebConPersonRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },
    async beforeMount() {
    },

  },
}
</script>

<style src="./ConPersonManagement.scss" lang="scss"/>
